import React, { useMemo } from 'react'
import { Bold } from '~/components'
import { ManWithDesktopPrimary } from '~/assets/illustrations'
import { Box, Typography } from '@material-ui/core'
import { useIsMobileScreen } from '~/hooks'

export const ConfirmDocumentsHeader: React.FC = () => {
  const isMobile = useIsMobileScreen()
  const illustrationSize = useMemo(() => isMobile ? 170 : 270, [isMobile])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      }}>
      <ManWithDesktopPrimary width={illustrationSize} height={illustrationSize} />
      <Typography variant={isMobile ? 'airbnbH4' : 'airbnbH2'} sx={{ fontWeight: 700, textAlign: 'center' }}>Você possui alterações não salvas</Typography>
      <Typography
        variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'}
        sx={{
          marginBottom: 3,
          textAlign: 'center',
          color: 'textGray1.main'
        }}>
        Salve seu progresso no botão abaixo antes de continuar. <Bold>Atenção:</Bold> se você continuar sem salvar, suas alterações serão perdidas.
      </Typography>
    </Box>
  )
}
